export default "__VITE_ASSET__Io_OvP1t__"